export default __webpack_public_path__ + "static/media/604.c1974b3c.png";